import { getOwners } from 'store/owners/actions'
import type { GetOwnersPayload } from 'store/owners/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'
import type { Owners } from 'store/owners/types'

import { useQuerySelect } from 'hooks'

type UseOwnersParams = GetOwnersPayload

type UseOwnersResult = {
  data: Owners | null
} & UseQuerySelectResult<UseOwnersParams>

export const useOwners = (params: UseOwnersParams, options?: UseQuerySelectOptions): UseOwnersResult => {
  const result = useQuerySelect(getOwners, params, options)
  const data = useSelector(state => state.owners.owners)
  return { data, ...result }
}
